export default class DirectCustomer {
    public readonly id: number;
    public readonly name: string;
    public readonly isPotentialBusinessPartner: boolean;

    constructor(json: any) {
        this.id = json.id;
        this.name = json.name;
        this.isPotentialBusinessPartner = json.isPotentialBusinessPartner ?? false;
    }
}
